<template>
  <div id="app">
    <div v-if="isSignedIn">
      <b-navbar toggleable="lg">
        <b-navbar-brand to="/">RiskyStuff</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/portfolio">Portfolio</b-nav-item>
            <b-nav-item to="/curve">Curve</b-nav-item>
            <b-nav-item to="/risk">Risk</b-nav-item>
            <b-nav-item to="/simulation">Simulation</b-nav-item>
          </b-navbar-nav>
        </b-collapse>

        <b-navbar-nav class="ml-auto">
          <b-nav-text class="username">
            <font-awesome-icon icon="user-tie" /> {{ userName }}</b-nav-text
          >
          <b-nav-item class="ml-3" to="/logout">Logout</b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>

    <router-view />
  </div>
</template>

<script>
import auth from "@/app/auth";
import UserInfoApi from "@/app/user-info-api";

export default {
  data() {
    return {
      userName: ""
    };
  },
  mounted() {
    if (auth.auth.isUserSignedIn()) {
      UserInfoApi.getUserInfo().then(response => {
        this.userName = response.username;
      });
    }
  },
  computed: {
    isSignedIn() {
      return auth.auth.isUserSignedIn();
    }
  }
};
</script>
